/** Fictional campaign and merchant labels for marketing mockups. */
export const DEMO_CAMPAIGNS = {
  homeRefresh: 'Anniversary Sale',
  springAudio: 'BFCM Priority SKUs'
} as const;

export const DEMO_MERCHANTS = {
  retailPartner: 'Retail partner',
  retailPartnerShort: 'RetailCo'
} as const;
